import React from 'react';
import '../main.css';

type TimelineProps = {Times:string[], Content:React.ReactNode[]} & React.PropsWithChildren<React.HTMLProps<HTMLDivElement>>
function Timeline(props:TimelineProps){
    return (
        <div className="grid grid-cols-5 w-3/4 lg:w-1/2 text-xl lg:text-2xl">
            { 
                props.Content.map((node, index) => (<React.Fragment key={index}>
                    <div className="col-span-1" key={"index"+index}>{props.Times[index]}</div> 
                    <div className="col-span-4" key={"line"+index}></div> 
                    <TimelineLine />
                    <div className="col-span-4" key={"node"+index}>{node}</div> 
                </React.Fragment>))
            }
            <div className="col-span-1">{props.Times.at(-1)}</div> 
        </div>
    )
}

function TimelineLine(props:React.PropsWithChildren<React.HTMLProps<HTMLDivElement>>){
    return (
        <div className="w-full h-full flex flex-col place-items-center">
            <div className="w-[3px] h-[3px] rounded-full bg-white my-1"/>
            <div className="grow w-[1px] bg-white"/>
            <div className="w-[3px] h-[3px] rounded-full bg-white my-1"/>
        </div>
    )
}

export default Timeline;